import React from "react";
import { Box, Typography } from "@mui/material";
import "./InfoBox.scss";

interface InfoBoxProps {
  label: string;
  value: string | number;
}

const InfoBox: React.FC<InfoBoxProps> = ({ label, value }) => {
  return (
    <Box className="info-box">
      <Typography className="label">
        {label}
      </Typography>
      <Typography className="value">
        {value}
      </Typography>
    </Box>
  );
};

export { InfoBox };
